module.exports = __webpack_public_path__ + "img/Filled.0201cc6b.png";